import React from "react";
import { connect } from "react-redux";
import { loadQuestionary, addResponse, removeResponse, addNumber, addText, addComposite, sendFormQuestionary, resetResponses } from "./action";
import { loadSubMenu, onAlertaPlanMovilidad } from "../../actions";
import Loading from "../../../Util/Loading";
import { scrollElementToTop, dataLayerTag } from "../../functions";

const ColoredLine = ({ color }) => (
  <hr
    style={{
      color,
      backgroundColor: color,
      height: 1,
    }}
  />
);

class EncuestaCentroPlanMovilidad extends React.PureComponent {
  constructor(props) {
    super(props);
    // editar, por que, lo inicializa siempre cuando estoy en otra etapa...
    this.props.dispatch(loadQuestionary());
  }

  componentDidMount = () => {
    if (this.props.estadoEncuestaCentro && this.props.estadoProceso === 2) {
      this.props.dispatch(onAlertaPlanMovilidad("warning", `Ya se realizó el diagnóstico para centro de trabajo de ${this.props.sucursalName}, puede volver a responderla.`));
    }
    scrollElementToTop("MENU_ETAPAS_PLAN_MOVILIDA");
  }

  // Recibo la pregunta y retorno dependiendo el type
  getResponse = (pregunta) => {
    switch (pregunta.type) {
      case "AT_LEAST_ONE":
        return (
          <div id={pregunta.codeQuestion} className="row PM-respuesta">
            {pregunta.responses.map((respuesta, r) => (
              <div key={r} id={r} className="col-md-12 PM-respuesta-ajuste" >
                <input
                  className="PM-position-absolute PM-margin-encuesta-especial"
                  type="checkbox"
                  name={pregunta.codeQuestion}
                  id={r}
                  key={r}
                  value={Object.keys(respuesta)}
                  onChange={(e) => {
                    if (e.target.checked) {
                      this.props.dispatch(addResponse(pregunta, respuesta));
                    } else {
                      this.props.dispatch(removeResponse(pregunta, respuesta));
                    }
                  }}
                />
                <p className="PM-mgl-25">{Object.values(respuesta)}</p>
              </div>))}
          </div>
        );

      case "JUST_ONE":
        if (pregunta.codeQuestion === "Q2") {
          return (
            <div id={pregunta.codeQuestion} className="row PM-respuesta">
              {pregunta.responses.map((respuesta, r) => (
                <div key={r} id={r} className="col-md-12 PM-respuesta-ajuste">
                  { (r === 0) ?
                    <input
                      className="PM-position-absolute PM-margin-encuesta-especial"
                      type="radio"
                      name={pregunta.codeQuestion}
                      id={r}
                      key={r}
                      value={Object.keys(respuesta)}
                      disabled
                    />
                    :
                    <input
                      className="PM-position-absolute PM-margin-encuesta-especial"
                      type="radio"
                      name={pregunta.codeQuestion}
                      id={r}
                      key={r}
                      value={Object.keys(respuesta)}
                      disabled
                      checked
                    />
                  }
                  <p className="PM-mgl-25">{Object.values(respuesta)}</p>
                </div>))}
            </div>);
        }
        return (
          <div id={pregunta.codeQuestion} className="row PM-respuesta">
            {pregunta.responses.map((respuesta, r) => (
              <div key={r} className="col-md-12 PM-respuesta-ajuste">
                <input
                  className="PM-position-absolute PM-margin-encuesta-especial"
                  type="radio"
                  name={pregunta.codeQuestion}
                  id={r}
                  key={r}
                  value={Object.keys(respuesta)}
                  onChange={() => this.props.dispatch(addResponse(pregunta, respuesta))}
                />
                <p className="PM-mgl-25">{Object.values(respuesta)}</p>
              </div>))}
          </div>);

      case "NUMBER":
        return (
          <div id={pregunta.codeQuestion} className="row PM-respuesta">
            <div className="col-md-12">
              <input style={{ width: "100%", padding: 5 }} type="number" name={pregunta.codeQuestion} min="0" max="999" onBlur={(e) => this.props.dispatch(addNumber(pregunta, e.target.value))} />
            </div>
          </div>);

      case "COMPOSITE":
        // tengo un tratamiento diferente para la cantidad de hombres y mujeres de la encuesta.
        if (pregunta.codeQuestion === "Q5") {
          return (
            <div id={pregunta.codeQuestion}>
              {pregunta.responses.map((respuesta, r) => (
                <div key={r} id={r} className="row PM-respuesta">
                  <div className="col-md-2 PM-pdt-10" >
                    <p>{Object.values(respuesta)}</p>
                  </div>
                  <div className="col-md-10">
                    <input
                      style={{ width: "100%", padding: 5 }}
                      type="number"
                      name={pregunta.codeQuestion}
                      min="0"
                      max="999"
                      onBlur={(e) => this.props.dispatch(addComposite(pregunta, respuesta, e.target.value))}
                      defaultValue={(Object.values(respuesta)[0] === "Nº de Hombres") ? ((this.props.cantidadHombresCentro !== -1) ? this.props.cantidadHombresCentro : "") : ((this.props.cantidadMujeresCentro !== -1) ? this.props.cantidadMujeresCentro : "")} />
                  </div>
                </div>
              ))}
            </div>);
        }
        return (
          <div id={pregunta.codeQuestion}>
            {pregunta.responses.map((respuesta, r) => (
              <div key={r} id={r} className="row PM-respuesta">
                <div className="col-md-2 PM-pdt-10">
                  <p>{Object.values(respuesta)}</p>
                </div>
                <div className="col-md-10" >
                  <input style={{ width: "100%", padding: 5 }} type="number" name={pregunta.codeQuestion} min="0" max="999" onBlur={(e) => this.props.dispatch(addComposite(pregunta, respuesta, e.target.value))} />
                </div>
              </div>
            ))}
          </div>);


      case "TEXT":
        if (pregunta.codeQuestion === "Q3") {
          return (
            <div id={pregunta.codeQuestion} className="row PM-respuesta">
              <div className="col-md-12">
                <input style={{ width: "100%", padding: 5 }} type="text" name={pregunta.codeQuestion} value={this.props.sucursalName} disabled />
              </div>
            </div>);
        }
        return (
          <div id={pregunta.codeQuestion} className="row PM-respuesta">
            <div className="col-md-12">
              <input style={{ width: "100%", padding: 5 }} type="text" name={pregunta.codeQuestion} onBlur={(e) => this.props.dispatch(addText(pregunta, e.target.value))} />
            </div>
          </div>);

      case "TEXTAREA":
        return (
          <div id={pregunta.codeQuestion} className="row PM-respuesta">
            <div className="col-md-12">
              <textarea rows="10" cols="200" onBlur={(e) => this.props.dispatch(addText(pregunta, e.target.value))} />
            </div>
          </div>
        );
      default:
        return (<div id={pregunta.codeQuestion} className="row PM-respuesta">INDEFINIDO</div>);
    }
  }

  render() {
    return (
      <div id="encuesta_centro_trabajo">
        { this.props.isLoading && <Loading /> }
        <section id="content-etapa">
          <div className="row" style={{ marginTop: 10, marginBottom: 5 }}>
            <div className="col-md-10">
            </div>
            <div className="col-md-2 text-right">
              <button
                className="btn PM-dx-button-plan PM-dx-button-plan-100"
                onClick={() => {
                  this.props.dispatch(resetResponses());
                  this.props.dispatch(loadSubMenu(0, 0));
                }}
              >Volver
              </button>
            </div>
          </div>
          { this.props.encuestaData.map((category, c) => (
            <div className="row PM-encuesta-centro-trabajo" key={c}>
              <div className="col-md-12">

                <div className="row">
                  <div className="col-md-12" id={category.codeCategory} >
                    <h2>{c + 1}. {category.title}</h2>
                  </div>
                </div>

                { category.subCategories.map((sub, sc) => (
                  <div className="row" key={sc}>
                    <div className="col-md-12 PM-info">
                      { sub.title !== "" && sub.title ? <h3>{c + 1}.{sc + 1}. {sub.title}</h3> : null}
                      { sub.text !== "" && sub.text ? <p className="PM-encuesta">{sub.text}</p> : null }
                    </div>
                    {/* tengo todas las rspuestas */}
                    {sub.questions.map((preg, q) => (
                      <div className="col-md-12 PM-box-pregunta" key={q}>
                        <span className="PM-pregunta">{q + 1}. {preg.question}</span>
                        { preg.help != "" && preg.help ? <p className="PM-encuesta-centro-trabajo-help">{preg.help}</p> : null }
                        {this.getResponse(preg)}
                      </div>))}
                  </div>))}

              </div>
              <div className="col-md-12">
                  <ColoredLine color="#F2F2F2" />
              </div>
            </div>))}
        </section>


        <div key="SAVEFORM" className="row PM-plan-botones-encuesta" style={{ marginBottom: 20 }}>
          <div className="col-md-12 PM-button">
            <button
              className="btn PM-dx-button-plan PM-dx-button-plan-40 PM-success-margin"
              onClick={() => {
                this.props.dispatch(sendFormQuestionary(
                  this.props.idplanMovilidad,
                  this.props.encuestaData,
                  this.props.encuestaResponses,
                  this.props.companyId,
                  this.props.sucursalId,
                  this.props.usuarioRUT,
                  this.props.sucursalName,
                  "a",
                  this.props.cantidadHombresCentro,
                  this.props.cantidadMujeresCentro
                ));
                dataLayerTag({
                  'event': 'etapa_2_finaliza_encuesta_ct',
                  'etapa': '2'
                });
              }}
              role="button"
            >Responder encuesta
            </button>
            <button
              className="btn PM-dx-button-plan-40 PM-solo-borde"
              onClick={() => {
                this.props.dispatch(resetResponses());
                this.props.dispatch(loadSubMenu(0, 0));
              }}
            >Salir sin guardar
            </button>
          </div>
        </div>


      </div>);
  }
}

const mapStateToProps = (state) => ({
  estadoEncuestaCentro: state.planMovilidad.estadoEncuestaCentro,
  cantidadHombresCentro: state.planMovilidad.cantidadHombresCentro,
  cantidadMujeresCentro: state.planMovilidad.cantidadMujeresCentro,
  encuestaData: state.encuesta.encuestaData,
  encuestaResponses: state.encuesta.encuestaResponses,
  isLoading: state.encuesta.isLoading,
  companyId: state.global.companyId,
  sucursalName: state.global.sucursalName,
  sucursalId: state.global.sucursalId,
  usuarioRUT: state.global.userData.RUT,
  estadoProceso: state.planMovilidad.estadoProceso,
  idplanMovilidad: state.planMovilidad.idplanMovilidad,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(EncuestaCentroPlanMovilidad);

